import Link from "next/link";

type ServiceCard1Props = {
  service: {
    featuredImage: string;
    title: string;
    slug: string;
  };
};

export default function ServiceCard1({ service }: ServiceCard1Props) {
  return (
    <Link href={`/expertise/${service.slug}`} className="block w-full">
        <div className="flex flex-col items-center justify-center w-full h-[280px] sm:h-[320px] md:h-[300px]
            px-6 sm:px-8 relative rounded-lg transition-transform duration-300 hover:scale-[1.02]"  
            style={{
            backgroundImage: `url(${service.featuredImage})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            }}
        >
            <div className="w-[90%] sm:w-[85%] md:w-[80%] py-4 sm:py-5 px-4 flex items-center justify-center
                absolute -bottom-6 bg-secondary rounded-lg shadow-lg transition-all duration-300 hover:bg-primary text-primary hover:text-white">
                <h4 className="text-[15px] sm:text-[16px] md:text-[17px] lg:text-[18px] uppercase font-medium text-center leading-snug">
                    {service.title}
                </h4>
            </div>
        </div>
    </Link>
  );
}